import React from 'react';
import { Wind, Sparkles } from 'lucide-react';
import { TRANSICOES } from '../data/estacoesContent';

// Estado de Transição — quando duas estações empatam tecnicamente.
// Uso:  {result.dominant?.type === 'transition' && <ResultadoTransicao result={result} />}
const ROOT_LABEL = { peregrino:'Peregrino', guardiao:'Guardião', amante:'Amante', alquimista:'Alquimista' };

const ResultadoTransicao = ({ result }) => {
  const dom = result?.dominant;
  if (!dom || dom.type !== 'transition') return null;
  const [a, b] = dom.roots;
  const key = [...dom.pair].sort().join('__');
  const tr = TRANSICOES[key];

  return (
    <div className="bg-gradient-to-br from-indigo-900/30 via-slate-900/40 to-violet-900/30 backdrop-blur-sm rounded-2xl p-6 md:p-7 border border-indigo-500/20 mb-6" data-testid="resultado-transicao">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 bg-gradient-to-br from-indigo-400 to-violet-400 rounded-full flex items-center justify-center flex-shrink-0">
          <Wind className="w-6 h-6 text-white" />
        </div>
        <div>
          <h3 className="text-xl md:text-2xl font-extrabold text-white">{tr ? tr.titulo : 'Você está em travessia'}</h3>
          <p className="text-white/50 text-xs">Travessia entre a estação do {ROOT_LABEL[a]} e a do {ROOT_LABEL[b]}</p>
        </div>
      </div>

      {tr ? (
        <div className="space-y-4">
          <p className="text-white/85 leading-relaxed" style={{ fontFamily: "'Lora', Georgia, serif" }}>{tr.dentro}</p>

          <div className="bg-white/5 rounded-xl p-4 border border-white/10">
            <p className="text-indigo-200/70 text-xs font-semibold uppercase tracking-widest mb-1.5">O convite desta travessia</p>
            <p className="text-white/80 leading-relaxed text-sm">{tr.convite}</p>
          </div>

          <div className="flex items-center gap-2 text-white/60 text-sm">
            <Sparkles className="w-4 h-4 text-amber-300" />
            <span>Nesta tensão, nasce <span className="text-amber-200 font-semibold">{tr.nascendo}</span>.</span>
          </div>

          <p className="text-center text-white/90 italic pt-1" style={{ fontFamily: "'Playfair Display', serif" }}>“{tr.semente}”</p>
        </div>
      ) : (
        <p className="text-white/80 leading-relaxed">
          Suas duas estações mais fortes estão lado a lado — sinal de que você vive uma passagem, não um ponto fixo.
          O resultado abaixo parte da força um pouco mais viva ({ROOT_LABEL[a]}), mas o {ROOT_LABEL[b]} caminha bem perto.
        </p>
      )}
    </div>
  );
};

export default ResultadoTransicao;
